module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_long_darkbrown.74d4c697.png";